import React from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import GuestPassLogTable from './GuestPassLogTable';
import { Spin, Alert } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const GuestPassLog: React.FC = () => {
    const { t } = useTranslation();
    const { isGuestPassIntegrated, isTokenValid, loading: integrationLoading } = useSelector(
        (state: RootState) => state.integration
    );

    // Show loading spinner while integration status is being fetched
    if (integrationLoading) {
        return (
            <OpPage title={t('guestPassLog.title')}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                </div>
            </OpPage>
        );
    }

    // Show error message if integration is not properly configured
    if (!isGuestPassIntegrated || !isTokenValid) {
        return (
            <OpPage title={t('guestPassLog.title')}>
                <Alert
                    message={t('guestPassLog.integrationRequired')}
                    description={t('guestPassLog.integrationRequiredDescription')}
                    type="warning"
                    showIcon
                />
            </OpPage>
        );
    }

    return (
        <OpPage title={t('guestPassLog.title')}>
            <GuestPassLogTable />
        </OpPage>
    );
}

export default GuestPassLog;
